<form>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>delete</mat-icon>
      Delete user address
    </h1>
  </section>
  <section mat-dialog-content="">
    <h2>Are you sure you want to delete this address?</h2>
    <p class="addressText">{{address.address.address1}}</p>
    <p class="addressText">{{address.address.address2}}</p>
    <p class="addressText">{{address.address.city}}</p>
    <p class="addressText">{{address.address.county}}</p>
    <p class="postcodeText">{{address.address.postCode}}</p>
    <p class="postcodeText">{{address.address.phone}}</p>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
    >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      mat-button
      matTooltip="Delete account."
      type="button"
      (click)="confirm()"
    >
      <mat-icon>done</mat-icon>
      Confirm
    </button>
  </section>
</form>
